<template>
<div style="z-index:1">
    <div class="titleHeader3">
           <s-l id="home_raisons"> Les 5 bonnes raisons d'utiliser <b>petanque-app</b></s-l>
    </div>
    <div class="header3">
        <div class="atout typesDeTournois">
                <div class="titleAtout" v-on:click="atout_explainTypes=!atout_explainTypes">
                <s-l id="home_raisonstt">De multiples types de tournois variés</s-l>
            </div>
        </div> 
        <s-modal
            :open="atout_explainTypes"
            :close="true"
            @close="atout_explainTypes=false"
            title="Concours variés"
        >
            
            <div class="description">
                <s-l id="atout_descripion_explainTypes">Beaucoup de type de tournois sont disponibles. En individuel, En Doublette, en triplette ou encore en triplette.</s-l>
            </div>

        </s-modal>
        <div class="atout gaindeTemps">
            
            <div class="titleAtout" v-on:click="atout_explainGDT=!atout_explainGDT">
                <s-l id="home_raisongain" >Un gain de temps incroyable</s-l>
            </div>
        </div> 
         <s-modal
            :open="atout_explainGDT"
            :close="true"
            @close="atout_explainGDT=false"
            title="Un gain de temps"
        >
            
            <div class="description">
                <s-l id="atout_descripion_explainGDT">Vous allez gagner un temps considérable ! Les tirages au sort sont rapides et efficaces.Concernant le concours GAGNANT GAGNANT .....</s-l>
            </div>

        </s-modal>

            <div class="atout hc">
            
            <div class="titleAtout" v-on:click="atout_explainHC=!atout_explainHC">
                <s-l id="home_raisonshc">Fonctionne en hors connexion</s-l>
            </div>
        </div>  
        <s-modal
            :open="atout_explainHC"
            :close="true"
            @close="atout_explainHC=false"
            title="Fonctionnement hors connexion"
        >
            
            <div class="description">
                <s-l id="atout_descripion_explainHC">Vous allez gagner un temps considérable ! Les tirages au sort sont rapides et efficaces.Concernant le concours GAGNANT GAGNANT .....</s-l>
            </div>

        </s-modal>
        <div class="atout connecte">
            
            <div class="titleAtout"  v-on:click="atout_explainJC=!atout_explainJC">
                <s-l id="home_raisonconnecte">Vos joueurs seront connectés</s-l>
            </div>
        </div> 
        <s-modal
            :open="atout_explainJC"
            :close="true"
            @close="atout_explainJC=false"
            title="Vos joueurs seront connectés"
        >
          
            <div class="description">
                <s-l id="atout_descripion_explainJC">Les joueurs peuvent être connectés à l'application, voir leurs statistiques et leurs classements dans leur club.</s-l>
        </div>

        </s-modal>
        <div class="atout classement">
            
                <div class="titleAtout"  v-on:click="atout_explainAUTO=!atout_explainAUTO">
                <s-l id="home_raisonsca">Classement automatique</s-l>
            </div>
        </div>    
        <s-modal
            :open="atout_explainAUTO"
            :close="true"
            @close="atout_explainAUTO=false"
            title="Classement"
        >
           
            <div class="description">
                <s-l id="atout_descripion_explainAUTO">Les classements sont automatiques... vous blab lbabal</s-l>
            </div>

        </s-modal>    
    </div>      
</div>
</template>
<style scoped>
.description {
    margin-left: 0px;
    padding-right: 20px;
    text-align: justify;
    font-size: 20px;
    color: black;
}
/* Photos ATOUT*/
.classement {
    background-image: url("../../assets/ATOUTCLASSEMENT.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.gaindeTemps {
    background-image: url("../../assets/gaindetemps.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.typesDeTournois {
    background-image: url("../../assets/TT.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}

.connecte {
    background-image: url("../../assets/ATOUTCC.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.hc {
    background-image: url("../../assets/nonCC.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
}
.atout:hover {
    border-color: rgb(194, 221, 194);
    cursor: pointer;
    border-radius: 10px;
    border-style: dashed;
    border-width: medium;
}
@media screen and (max-width: 1025px) {
    
    .titleHeader3 {
        color: var(--bluebg);
        font-size: 18px;
        font-weight: bolder;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 20px;
        width: 100%;
    }
    .header3 {
        display: flex;
        height: 200px;
        overflow-x: auto;
    }
    .atout {
        width: 120px;
        margin-left: 20px;
        margin-right: 20px;
        flex: 0 0 auto;
        height: 120px;
    }
    .titleAtout {
        position: relative;
        padding-top: 130px;
        font-size: 14px;
        font-weight: bolder;
        color: black;
        width: 150px;
        text-align:center;
    }
}
@media screen and (min-width: 1025px) {
    .header3 {
        display: flex;
        height: 280px;
        overflow-x: auto;
        justify-content: center;
         
    }
    
    .titleHeader3 {
        color: var(--bluebg);
        font-size: 30px;
        font-weight: bolder;
        padding-left: 30px;
        margin-bottom: 20px;
    }
    .titleAtout {
        position: relative;
        padding-top: 150px;
        font-size: 18px;
        font-weight: bolder;
        color: black;
        width: 150px;
        text-align:center;
    }
    .atout {
        width: 150px;
        margin-left: auto;
        margin-right: auto;
        height: 150px;
    }
}
</style>
<script>
export default {
    data() {
        return {
            atout_explainTypes: false,
            atout_explainGDT: false,
            atout_explainHC: false,
            atout_explainJC: false,
            atout_explainAUTO: false
        }
    }
}
</script>